import {Routes} from '@angular/router';
import {SaleManagementComponent} from './sale.management.component';
import {equityManagementRoutes} from './equity-management/equity.management.routes';
import {memberManagementRoutes} from './member-management/member-management.routes';
import {rollManagementRoutes} from './roll-management/roll.management.routes';
import {prizeManagementRoutes} from './prize-management/prize.management.routes';
import {cashManagementRoutes} from './cash-management/cash.management.routes';
import {giftManagementRoutes} from "./gift-management/gift-management-routes";
import {releaseManagementRoutes} from "./release-management/release-management-routes";
import {orderManagementRoutes} from "./order-management/order-management-routes";
import {acceptManagementRoutes} from "./accept-management/accept-management-routes";
import {returngoodsManagementRoutes} from "./returngoods-management/returngoods-management-routes";
import {returnmoneyManagementRoutes} from "./returnmoney-management/returnmoney-management-routes";
import {afterserviceManagementRoutes} from "./afterservice-management/afterservice-management-routes";
import {shipmentManagementRoutes} from "./shipment-management/shipment-management-routes";
import {redpacketManagementRoutes} from "./redpacket-management/redpacket-management-routes";
import {serviceManagementRoutes} from "./service-management/service-management-routes";
import {bannerRecommendationRoutes} from "./banner-recommendation/banner-recommendation.routes";
import {categoryRecommendationRoutes} from "./category-recommendation/category-recommendation.routes";
import {
  consumermerchantsRecommendationRoutes
} from "./consumermerchants-recommendation/consumermerchants-recommendation.routes";
import {combinationRecommendationRoutes} from "./combination-recommendation/combination-recommendation.routes";
import {selectionRecommendationRoutes} from "./selection-recommendation/selection-recommendation.routes";
import {regionManagementRoutes} from "./region-management/region.management.routes";
import {groupbuyingRecommendationRoutes} from "./groupbuying-recommendation/groupbuying-recommendation.routes";
import {layerRecommendationRoutes} from "./layer-recommendation/layer-recommendation.routes";
import {categoryManagementRoutes} from "./category-management/category.management.routes";
import {goodszoneRecommendationRoutes} from "./goodszone-recommendation/goodszone-recommendation.routes";

export const saleManagementRoutes: Routes = [
  {
    path: 'sale.management',
    component: SaleManagementComponent,
    data: { title: '商城后台管理' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./index/index.component').then(m => m.IndexComponent),
        data: { title: '首页' },
      },
      {
        path: 'userDeliveryManagement',
        loadComponent: () => import('./user-delivery-management/user-delivery-management.component').then(m => m.UserDeliveryManagementComponent),
        data: { title: '配送员用户' },
      },
      {
        path: 'saleDeliveryResourcesAuthorization/:accountId',
        loadComponent: () => import('./user-delivery-management/sale-delivery-resources-authorization/sale-delivery-resources-authorization.component').then(m => m.SaleDeliveryResourcesAuthorizationComponent),
        data: { title: '配送员资源授权' },
      },
      ...categoryManagementRoutes,
      {
        path: 'logisticsManagement',
        loadComponent: () => import('./logistics-management/logistics-management.component').then(m => m.LogisticsManagementComponent),
        data: { title: '快递信息管理' },
      },
      {
        path: 'groupbuyingcommManagement',
        loadComponent: () => import('./groupbuying-recommendation/groupbuying-recommendation.component').then(m => m.GroupbuyingRecommendationComponent),
        data: { title: '团购推荐管理' },
      },
      {
        path: 'combocommManagement',
        loadComponent: () => import('./combination-recommendation/combination-recommendation.component').then(m => m.CombinationRecommendationComponent),
        data: { title: '套装推荐管理' },
      },
      {
        path: 'releasepriceManagement',
        loadComponent: () => import('./releaseprice-management/releaseprice-management.component').then(m => m.ReleasepriceManagementComponent),
        data: { title: '商品价格管理' },
      },
      {
        path: 'shopManagement',
        loadComponent: () => import('./shop-management/shop-management.component').then(m => m.ShopManagementComponent),
        data: { title: '商店管理' },
      },
      {
        path: 'shopgrantManagement',
        loadComponent: () => import('./shopgrant-management/shopgrant.management.component').then(m => m.ShopgrantManagementComponent),
        data: { title: '店铺授权' },
      },
      {
        path: 'evaluateTagsManagement',
        loadComponent: () => import('./evaluate-tags-management/evaluate-tags-management.component').then(m => m.EvaluateTagsManagementComponent),
        data: { title: '商品评价标签' },
      },
      {
        path: 'evaluateContentManagement',
        loadComponent: () => import('./evaluate-content-management/evaluate-content-management.component').then(m => m.EvaluateContentManagementComponent),
        data: { title: '评价内容模版' },
      },
      {
        path: 'evaluateImagesManagement',
        loadComponent: () => import('./evaluate-images-management/evaluate-images-management.component').then(m => m.EvaluateImagesManagementComponent),
        data: { title: '评价图片模版' },
      },
      {
        path: 'memberEvaluateManagement',
        loadComponent: () => import('./member-evaluate-management/member-evaluate-management.component').then(m => m.MemberEvaluateManagementComponent),
        data: { title: '用户评价管理' },
      },
      {
        path: 'questionsManagement',
        loadComponent: () => import('./questions-management/questions-management.component').then(m => m.QuestionsManagementComponent),
        data: { title: '常见问题管理' },
      },

      {
        path: 'releaseCheckinManagement',
        loadComponent: () => import('./release-checkin-management/release-checkin-management.component').then(m => m.ReleaseCheckinManagementComponent),
        data: {title: "商品签到管理"},
      },
      {
        path: 'releaseShareManagement',
        loadComponent: () => import('./release-share-management/release-share-management.component').then(m => m.ReleaseShareManagementComponent),
        data: {title: "分享返佣管理"},
      },
      {
        path: 'releaseIntegrateManagement',
        loadComponent: () => import('./release-integrate-management/release-integrate-management.component').then(m => m.ReleaseIntegrateManagementComponent),
        data: {title: "商品积分管理"},
      },
      {
        path: 'integrateMoneyManagement',
        loadComponent: () => import('./integrate-money-management/integrate-money-management.component').then(m => m.IntegrateMoneyManagementComponent),
        data: {title: "积分现金管理"},
      },
      {
        path: 'bindGiftManagement',
        loadComponent: () => import('./bind-gift-management/bind-gift-management.component').then(m => m.BindGiftManagementComponent),
        data: { title: '绑定送礼品' },
      },
      {
        path: 'soldOutSkuManagement',
        loadComponent: () => import('./soldoutsku-management/soldoutsku-management.component').then(m => m.SoldoutskuManagementComponent),
        data: { title: '售罄商品管理' },
      },
      {
        path: 'groupBuyingManagement',
        loadComponent: () => import('./groupbuying-management/groupbuying-management.component').then(m => m.GroupbuyingManagementComponent),
        data: { title: '团购商品管理' },
      },
      {
        path: 'shareDescriptionManagement',
        loadComponent: () => import('./share-description-management/share-description-management.component').then(m => m.ShareDescriptionManagementComponent),
        data: { title: '分享描述管理' },
      },
      {
        path: 'shareReleaseDescriptionManagement',
        loadComponent: () => import('./share-release-description-management/share-release-description-management.component').then(m => m.ShareReleaseDescriptionManagementComponent),
        data: { title: '分享描述管理' },
      },
      {
        path: 'auditbalanceManagement',
        loadComponent: () => import('./auditbalance-management/auditbalance.management.component').then(m => m.AuditbalanceManagementComponent),
        data: { title: '提现审核管理' },
      },
      {
        path: 'addAuditbalance',
        loadComponent: () => import('./auditbalance-management/add.auditbalance/add.auditbalance.component').then(m => m.AddAuditbalanceComponent),
        data: { title: '审核用户提现' },
      },
      {
        path: 'shedulingManagement',
        loadComponent: () => import('./sheduling.management/sheduling.management.component').then(m => m.ShedulingManagementComponent),
        data: { title: '系统调度管理' },
      },
      {
        path: 'jobManagement',
        data: { title: '调度任务管理' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./job.management/job.management.component').then(m => m.JobManagementComponent),
            data: { title: '系统调度管理' },
          },
          {
            path: 'jobTriggerManagement/:jobName',
            loadComponent: () => import('./job.management/job.trigger.management/job.trigger.management.component')
              .then(m => m.JobTriggerManagementComponent),
            data: { title: '调度作业管理' },
          },
        ]
      },
      {
        path: 'consumermerchantsManagement',
        loadComponent: () => import('./consumermerchants-management/consumermerchants-management.component').then(m => m.ConsumermerchantsManagementComponent),
        data: { title: '好掌柜商品' },
      },
      ...goodszoneRecommendationRoutes,
      ...layerRecommendationRoutes,
      ...groupbuyingRecommendationRoutes,
      ...regionManagementRoutes,
      ...selectionRecommendationRoutes,
      ...combinationRecommendationRoutes,
      ...consumermerchantsRecommendationRoutes,
      ...categoryRecommendationRoutes,
      ...bannerRecommendationRoutes,
      ...releaseManagementRoutes,
      ...serviceManagementRoutes,
      ...giftManagementRoutes,
      ...equityManagementRoutes,
      ...memberManagementRoutes,
      ...rollManagementRoutes,
      ...prizeManagementRoutes,
      ...cashManagementRoutes,
      ...orderManagementRoutes,
      ...acceptManagementRoutes,
      ...returngoodsManagementRoutes,
      ...returnmoneyManagementRoutes,
      ...afterserviceManagementRoutes,
      ...shipmentManagementRoutes,
      ...redpacketManagementRoutes,
    ]
  },
];
